import { TextProps } from "../../types/textTypes";
import "./large.scss";

const Large: React.FC<TextProps> = ({ children, className }) => {
  return <p className={`largeText ${className}`}>{children}</p>;
};

export default Large;
